module.exports = __webpack_public_path__ + "img/favicon-16x16.7f279fc.png";